const MAX_AMOUNT_OF_TAGS = 3;

export const useHotelTags = () => ({ MAX_AMOUNT_OF_TAGS });
